module.exports = __webpack_public_path__ + "img/logo1.2b730f45.jpg";